/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterDeliveryOptions_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterLocation_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterDeliveryOptions_itemSearch";
};
export type SbSharedRefineMenuFilterDeliveryOptions_itemSearch$data = SbSharedRefineMenuFilterDeliveryOptions_itemSearch;
export type SbSharedRefineMenuFilterDeliveryOptions_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterDeliveryOptions_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterDeliveryOptions_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterDeliveryOptions_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterLocation_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'd5e62a0b54beeb62c5d83d070b4fb0bb';
export default node;
